import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=5ec7b14d&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=js"
export * from "./Quote.vue?vue&type=script&lang=js"
import style0 from "./Quote.vue?vue&type=style&index=0&id=5ec7b14d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec7b14d",
  null
  
)

export default component.exports